import React, { useEffect } from "react";
import { connect } from "react-redux";

import Collapsible from "./Collapsible";

const CollapsibleContainer = (props) => {

  return props.placeNumber && props.expandedPlace ? (
    <Collapsible
      {...props}
      active={props.expandedPlace === props.placeNumber}
    />
  ) : (
    <Collapsible {...props} />
  );
};

const stateToProps = (state) => ({
  //   expandedPlace: state.panel.expandedPlace,
});

export default connect(stateToProps, null)(CollapsibleContainer);
